// initial state
const state = () => ({
  ifRender: false,
})

// getters
const getters = {

    getRender(state) {
        return state;
    },

}

// mutations
const mutations = {

    setRender(state, payload) {
      state.ifRender = payload;
    }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
